import CompleteTask from '../../modules/Task/CompleteTask'
import ReferralModal from '../../modules/Contacts/Referral/Referral'
import CallModal from '../../modules/ClickToCall/CallModal'
import TaskModal from '../../modules/Task/Task'
import RelatedEntities from '../../modules/Contacts/TableOfContacts/RelatedEntities'
import EnterFilterInfo from '../../modules/LandingPages/components/EnterFilterInfo'
import ViewTimelineModal from '../../modules/ReferralReport/ViewTimelineModal'
import CallsTable from '../../modules/SalesMetricReport/CallsTable'
import ActivitiesTable from '../../modules/SalesMetricReport/ActivitiesTable'
import SalesMetricContactTable from '../../modules/SalesMetricReport/SalesReportContactTable'
import SMSTableModal from '../../modules/SalesMetricReport/SMSTableModal'
import FollowUpReport from '../../modules/Contacts/FollowUpReport/contactForFollowUpReport'
import ComponentConverting from '../../common/ContactCommonComponents/ConvertingContacts/index'
import ComponentConvertingLessee from '../../common/ContactCommonComponents/ConvertingContacts/ConvertContactLessee'
import ChangeLessee from '../../modules/Contacts/Contact/components/ChangeLessee'
import AddTruckSalesDealer from '../../modules/TruckSalesDealers/TableOfTSDealers/AddNewTSDealer'
import DayRating from '../../modules/Users/DayRating'
import PaymentReferral from '../../modules/ReferralReport/PaymentModal'
import GiveUpModal from '../ContactCommonComponents/ContactContainer/components/GiveUp'
import MarkContractLostModal from '../../modules/ContractLostHistory/MarkContractLostModal'
import ContactsByPhoneNumber from '../../modules/IncomingCall/ContactsByPhoneNumber'
import { OpportunityForm } from '../../modules/Opportunities/OpportunityForm'
import AccountsInsightsContactTable from '../../modules/Dashboard/Components/AccountsInsights/components/contact/ContactTable'
import CommentModal from '../../modules/Calendar/Comments/CommentForm'
import SharedNoteModal from '../../modules/SharedNotes/SharedNoteForm'
import ActivitySummaryContactModal from '../../modules/Dashboard/Components/Actions/ActivitySummary/components/ActivitySummaryContactModal'
import PossibleContacts from '../../modules/Credit/Applications/components/PossibleContacts'
import AssignSalespersonModal from '../../modules/Credit/Applications/components/AssignSalespersonModal'
import LoadsForm from '../../modules/CustomerLogisticsLoads/components/LoadsForm'
import CombineContacts from '../../modules/Contacts/TableOfContacts/CombineContacts'
import ConvertUnassignedProspect from '../ContactCommonComponents/ConvertingContacts/ConvertUnassignedProspect'
import OpportunitiesTable from '../../modules/Dashboard/Components/OpportunityChart/components/OpportunitiesTable'
import StageProspectsTable from '../../modules/Dashboard/Components/OpportunityChart/components/ProspectsTable'
import ChangeContactStatus from '../../modules/Contacts/TableOfContacts/ChangeContactStatus'
import UsStatesContactTable from '../../modules/States/MapOfStatesCompanyType/ContactTable'
import SharedResourceForm from '../../modules/SharedResources/SharedResourceForm'

const modalsArray = []
modalsArray['change-contact-status'] = {
  Component: ChangeContactStatus,
  size: 1000,
  modalTop: 20,
  modalLeft: 25,
}
modalsArray['incoming-call-contact'] = {
  Component: ContactsByPhoneNumber,
  size: 1100,
  modalTop: 20,
  modalLeft: 20,
  overflowY: 'auto',
}
modalsArray['mark_contract_lost'] = {
  Component: MarkContractLostModal,
  title: 'Contract Lost Details',
  size: 800,
  modalTop: 20,
  modalLeft: 25,
}
modalsArray['give_up'] = {
  Component: GiveUpModal,
  title: 'Give Up On Contact?',
  size: 500,
  modalTop: 28,
  modalLeft: 40,
}
modalsArray['payment_referral'] = {
  Component: PaymentReferral,
  title: 'Payment Referral',
  size: 400,
  modalTop: 28,
  modalLeft: 40,
}
modalsArray['convert_unassigned_prospect'] = {
  Component: ConvertUnassignedProspect,
  title: 'Convert Unassigned Prospect',
  size: 600,
  modalTop: 28,
  modalLeft: 27,
}
modalsArray['converting_contacts'] = {
  Component: ComponentConverting,
  title: 'Converting Contact',
  size: 600,
  modalTop: 28,
  modalLeft: 27,
}
modalsArray['converting_contacts_lessee'] = {
  Component: ComponentConvertingLessee,
  title: 'Converting Contact',
  size: 600,
  modalTop: 15,
  modalLeft: 30,
}
modalsArray['change_lessee'] = {
  Component: ChangeLessee,
  title: 'Change Lessee',
  size: 600,
  modalTop: 15,
  modalLeft: 30,
  overflowY: 'auto',
}
modalsArray['sales_metric_contacts'] = {
  Component: SalesMetricContactTable,
  title: 'Sales Metric Contacts',
  size: 1300,
  overflowY: 'auto',
}

modalsArray['accounts_insights_contacts_modal'] = {
  Component: AccountsInsightsContactTable,
  title: 'Contacts',
  size: 1600,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
}

modalsArray['complete_task'] = {
  Component: CompleteTask,
  title: 'Complete Task',
  size: 950,
  overflowY: 'auto',
}
modalsArray['calls_table'] = {
  Component: CallsTable,
  title: 'Calls Table',
  size: 950,
}
modalsArray['sms_table'] = {
  Component: SMSTableModal,
  title: 'SMS Messages',
  size: 1200,
  overflowY: 'auto',
}
modalsArray['sales_metric_activities'] = {
  Component: ActivitiesTable,
  title: 'Calls Table',
  size: 950,
  overflowY: 'auto',
}
modalsArray['referral'] = {
  Component: ReferralModal,
  title: 'Referral Dialog',
  size: 950,
}
modalsArray['referral_timeline'] = {
  Component: ViewTimelineModal,
  title: 'Referral Timeline',
  size: 950,
}
modalsArray['clickToCall'] = {
  Component: CallModal,
  title: 'Edit Activity',
  size: 950,
  overflowY: 'auto',
}
modalsArray['task_modal'] = {
  Component: TaskModal,
  title: 'Task Change This',
  size: 950,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
}
modalsArray['comment_modal'] = {
  Component: CommentModal,
  title: 'Add Comment',
  size: 950,
}
modalsArray['shared_notes_modal'] = {
  Component: SharedNoteModal,
  title: 'Add Shared Note',
  size: 950,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
}
modalsArray['related_entities'] = {
  Component: RelatedEntities,
  title: 'Possible Duplicates',
  size: 1100,
}
modalsArray['enter_filter_info'] = {
  Component: EnterFilterInfo,
  title: 'Enter Filter Info',
  size: 700,
}
modalsArray['follow-up-report'] = {
  Component: FollowUpReport,
  title: 'Follow Up Report',
  size: 1100,
  overflowY: 'auto',
}
modalsArray['day_rating'] = {
  Component: DayRating,
  title: 'Day Rating',
  size: 1000,
}
modalsArray['add_ts_dealer'] = {
  Component: AddTruckSalesDealer,
  title: 'Create Dealer',
  size: 450,
  modalLeft: 40,
}

modalsArray['opportunity_modal'] = {
  Component: OpportunityForm,
  size: 800,
  modalTop: 20,
  modalLeft: 25,
}

modalsArray['activity_summary_contacts_modal'] = {
  Component: ActivitySummaryContactModal,
  title: 'Contacts',
  size: 1200,
  overflowY: 'auto',
}

modalsArray['possible_contacts_modal'] = {
  Component: PossibleContacts,
  title: 'Possible Contacts',
  size: 950,
  overflowY: 'auto',
}

modalsArray['assign_salesperson_modal'] = {
  Component: AssignSalespersonModal,
  title: 'Assign Salesperson',
  size: 600,
  modalTop: 25,
  modalLeft: 35,
}

modalsArray['create_load'] = {
  Component: LoadsForm,
  title: 'Add New Load',
  size: 950,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
}

modalsArray['dashboard_opportunities_modal'] = {
  Component: OpportunitiesTable,
  title: 'Opportunities',
  size: 1200,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
}

modalsArray['stage_prospects_modal'] = {
  Component: StageProspectsTable,
  title: 'Opportunities',
  size: 1200,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
}

modalsArray['combine_contacts'] = {
  Component: CombineContacts,
  title: 'Combine Contacts',
  size: 1200,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
}

modalsArray['us_map_contacts'] = {
  Component: UsStatesContactTable,
  title: 'Contacts',
  size: 1400,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
}

modalsArray['shared_resource_modal'] = {
  Component: SharedResourceForm,
  title: 'Shared Document',
  size: 950,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
}

export default modalsArray

export const getModal = (id) => {
  return modalsArray[id]
}
